/**
 * Random id generation that also works on a plain-HTTP origin.
 *
 * `crypto.randomUUID` is gated to secure contexts, and this app is explicitly
 * meant to run against a LAN Gateway — where the UI itself is often served over
 * plain `http://`. `crypto.getRandomValues` has no such gate, so it carries the
 * fallback; only a context with no WebCrypto at all reaches the last resort.
 */
export function randomId(): string {
  const cryptoObj = globalThis.crypto;
  if (typeof cryptoObj?.randomUUID === "function") {
    return cryptoObj.randomUUID();
  }
  if (typeof cryptoObj?.getRandomValues === "function") {
    const bytes = cryptoObj.getRandomValues(new Uint8Array(16));
    // Shape the bytes as a v4 UUID so ids stay indistinguishable downstream.
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }
  return `id-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
